//
//
//
//
//
//
//

import Doughnut from './../../../components/elements/charts/Doughnut';

export default {
    name: "team-doughnut",
    props: ['title', 'data', 'labels'],
    components: {
        'chart-doughnut': Doughnut,
    },
    data() {
        return {
            doughnutOptions: {
                maintainAspectRatio: true,
                responsive: true,
            },
            stats: {
                labels: ['Réussis', 'Ratés'],
                datasets: [{
                    backgroundColor: ['#25ce82', '#ff3c3c'],
                    data: []
                }]
            },
        }
    },
    mounted() {
        this.stats.labels[0] = this.labels[0];
        this.stats.labels[1] = this.labels[1];
        this.stats.datasets[0].data = [this.data[0], this.data[1]];
    }
}
